export class ContentTodayPanel {
  idadvisioriesViewAllLink: any;
  arrive: any;
  bookFlightLink: any;
  checkinLabel: any;
  checkinLink: any;
  checkinNewWindow: any;
  depart: any;
  findAlternate: any;
  gateLabel: any;
  id: any;
  label: any;
  myTripsLink: any;
  operatedby: any;
  remainOnFlight: any;
  seatLabel: any;
  skymilesMember: any;
  statusLabel: any;
  viewBoardingLink: any;
  viewBoardingNewWindow: any;
  viewBoardingPass: any;
  viewTripDetails: any;
  was: any;
  isDelta: any;
  redirectNewCheckIn: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['statusLabel']) {
        this.statusLabel = contentjson['statusLabel'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['gateLabel']) {
        this.gateLabel = contentjson['gateLabel'];
      }
      if (contentjson['skymilesMember']) {
        this.skymilesMember = contentjson['skymilesMember'];
      }
      if (contentjson['seatLabel']) {
        this.seatLabel = contentjson['seatLabel'];
      }
      if (contentjson['checkinLabel']) {
        this.checkinLabel = contentjson['checkinLabel'];
      } else {
        this.checkinLabel = '';
      }
      if (contentjson['checkinLink']) {
        this.checkinLink = contentjson['checkinLink'];
      } else {
        this.checkinLink = '';
      }
      if (contentjson['checkinNewWindow']) {
        this.checkinNewWindow = contentjson['checkinNewWindow'];
      } else {
        this.checkinNewWindow = '';
      }
      if (contentjson['viewBoardingPass']) {
        this.viewBoardingPass = contentjson['viewBoardingPass'];
      } else {
        this.viewBoardingPass = '';
      }
      if (contentjson['viewBoardingLink']) {
        this.viewBoardingLink = contentjson['viewBoardingLink'];
      } else {
        this.viewBoardingLink = '';
      }
      if (contentjson['viewBoardingNewWindow']) {
        this.viewBoardingNewWindow = contentjson['viewBoardingNewWindow'];
      } else {
        this.viewBoardingNewWindow = '';
      }
      if (contentjson['operatedby']) {
        this.operatedby = contentjson['operatedby'];
      } else {
        this.operatedby = '';
      }
      if (contentjson['depart']) {
        this.depart = contentjson['depart'];
      } else {
        this.depart = '';
      }
      if (contentjson['arrive']) {
        this.arrive = contentjson['arrive'];
      } else {
        this.arrive = '';
      }
      if (contentjson['was']) {
        this.was = contentjson['was'];
      } else {
        this.was = '';
      }
      if (contentjson['remainOnFlight']) {
        this.remainOnFlight = contentjson['remainOnFlight'];
      } else {
        this.remainOnFlight = '';
      }
      if (contentjson['viewTripDetails']) {
        this.viewTripDetails = contentjson['viewTripDetails'];
      } else {
        this.viewTripDetails = '';
      }
      if (contentjson['findAlternate']) {
        this.findAlternate = contentjson['findAlternate'];
      } else {
        this.findAlternate = '';
      }
      if (contentjson['idadvisioriesViewAllLink']) {
        this.idadvisioriesViewAllLink = contentjson['idadvisioriesViewAllLink'];
      } else {
        this.idadvisioriesViewAllLink = '';
      }
      if (contentjson['bookFlightLink']) {
        this.bookFlightLink = contentjson['bookFlightLink'];
      } else {
        this.bookFlightLink = '';
      }
      if (contentjson['myTripsLink']) {
        this.myTripsLink = contentjson['myTripsLink'];
      } else {
        this.myTripsLink = '';
      }
      if (contentjson['accountOverview']) {
        this.isDelta = contentjson['accountOverview'];
      } else {
        this.isDelta = 'true';
      }
    }
  }
}
